import type {ProfileComparisonDeltaVariant} from '../../types/ProfileComparisonTypes';

export const PROFILE_COMPARISON_DELTA_THRESHOLD = 1;

export const getProfileComparisonDeltaVariant = (
  delta: number | null,
  threshold: number = PROFILE_COMPARISON_DELTA_THRESHOLD,
): ProfileComparisonDeltaVariant | null => {
  if (delta === null) {
    return null;
  }

  if (Math.abs(delta) <= threshold) {
    return 'flat';
  }

  return delta > 0 ? 'up' : 'down';
};
